import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { PageHint } from '@components/common/PageHint.tsx';
import { PageIndices } from '../../../common/i-doc/i-doc.registry.ts';
import { LegacyColumn, LegacyListTable, yesNo } from '@components/pm/legacy/LegacyListTable.tsx';
import { LegacyOrg, pmLegacyService } from '@services/pm-legacy.service.ts';

const COLUMNS: LegacyColumn<LegacyOrg>[] = [
  { label: 'ID', render: (r) => r.id },
  {
    label: 'Назва',
    render: (r) => (
      <>
        <Typography variant="body2" fontWeight={500}>{r.name || '—'}</Typography>
        {r.isDeleted && <Typography variant="caption" color="error">видалена</Typography>}
      </>
    ),
  },
  { label: 'Тариф', render: (r) => r.pack },
  {
    label: 'Клієнтів',
    align: 'center',
    render: (r) => <Link component={RouterLink} to={`/pm/legacy/clients?orgId=${r.id}`}>{r.clientsCount}</Link>,
  },
  {
    label: 'Експертів',
    align: 'center',
    render: (r) => <Link component={RouterLink} to={`/pm/legacy/experts?orgId=${r.id}`}>{r.expertsCount}</Link>,
  },
  { label: 'Активних у застосунку', render: (r) => r.activeAppClients, align: 'center' },
  { label: 'Пробний', render: (r) => (r.isTrial ? `так${r.trialEndsAt ? ` · до ${r.trialEndsAt}` : ''}` : '—'), nowrap: true },
  { label: 'Оплачено до', render: (r) => r.paidUntil, nowrap: true },
  { label: 'Платоспроможна', render: (r) => yesNo(r.isSolvent), align: 'center' },
  { label: 'Призупинена', render: (r) => yesNo(r.isSuspended), align: 'center' },
  { label: 'Країна / мова', render: (r) => [r.country, r.locale].filter(Boolean).join(' / ') || null },
  { label: 'Створена', render: (r) => r.createdAt, nowrap: true },
];

const PmLegacyOrgsPageContent: React.FC = () => (
  <Box data-i-doc={PageIndices.PM_LEGACY_ORGS}>
    <PageHint iDoc={PageIndices.PM_LEGACY_ORGS} />
    <LegacyListTable
      storageKey="pm-legacy-orgs"
      searchLabel="Пошук: ID, назва, контакт"
      columns={COLUMNS}
      fetch={pmLegacyService.getOrgs}
    />
  </Box>
);

export const PmLegacyOrgsPage: React.FC = () => (
  <DashboardLayout>
    <PmLegacyOrgsPageContent />
  </DashboardLayout>
);
